'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToStagedThread = navigateToStagedThread;

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _loadStagedThread = require('./loadStagedThread');

function navigateToStagedThread() {
  return function (dispatch) {
    dispatch((0, _loadStagedThread.loadStagedThread)());

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'create new thread'
    }));
  };
}